import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { api } from "../../../common/api/api";
import Component from "./Common";
import InfoBuilder from "./InfoBuilder";
import InfoBuilderSP from "./InfoBuilderSP";
import Pc from "../../../common/breakpoints/Pc";
import Sp from "../../../common/breakpoints/Sp";
import Button from "@material-ui/core/Button";
import PhoneIcon from "@material-ui/icons/Phone";
import {
  getSiteInfo,
  getSiteInfoStaff,
  getSiteInfoSupplier,
  getStaffCandidates,
  getSupplierCandidates,
  getType
} from "./reducer/reducer";
import {
  fetchSiteInfo,
  fetchSiteInfoStaff,
  fetchSiteInfoSupplier,
  fetchStaffCandidates,
  fetchSupplierCandidates,
  addStaffCandidate,
  addSupplierCandidate,
  deleteBuilderStaffCandidate,
  deleteSupplierStaffCandidate,
  fetchInfoData,
  showHideDialogStaff,
  showHideDialogSupplier
} from "./service/service";
import { dispatchError as fillError } from "../../../common/Stores/service/service";
import Popover from "@material-ui/core/Popover";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Fab from "@material-ui/core/Fab";
import CloseIcon from "@material-ui/icons/Close";
import InfoStaffDialog from "./InfoStaffDialog";
import InfoSupplierDialog from "./InfoSupplierDialog";
import jwt_decode from "jwt-decode";
import logmeetConfig from "../../../common/config/LogmeetConfig";
import { configStorage } from "../../../common/storage/storage";

class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogDeleteShow: false,
      isDialogStaffShow: false,
      isDialogSupplierShow: false,
      isDialogEdit: false,
      currentIds: [],
      anchorEl: null,
      userType: "",
      isSP: false,
      currentUserUniqueCode: null,
      receiver: null
    };
  }

  componentWillMount() {
    const token = localStorage.jwtToken
      ? localStorage.jwtToken
      : api.defaults.headers.common["Authorization"];
    const decoded = jwt_decode(token);
    this.setState({ currentUserUniqueCode: decoded.uniqueCode });
  }

  toggleCallModal = (receiver) => {
    this.setState({
      receiver: receiver ? receiver : null
    })
  }

  render() {
    const { anchorEl, popoverValue, userType, currentUserUniqueCode, receiver } = this.state;

    const {
      match,
      staffCandidates,
      supplierCandidates,
      addStaffCandidate,
      addSupplierCandidate,
      deleteBuilderStaffCandidate,
      deleteSupplierStaffCandidate,
      siteInfoStaff,
      siteInfoSupplier,
      logMeetFlag
    } = this.props;

    const toggleDialogStaff = () => {
      this.setState({
        currentIds: []
      });
      this.props.showHideDialogStaff();
    };

    const toggleDialogSupplier = () => {
      this.setState({
        currentIds: []
      });
      this.props.showHideDialogSupplier();
    };

    const handleAddStaffCandidate = staffIds => {
      const value = {
        sitesUC: match.params.id,
        usersUCs: staffIds
      };

      addStaffCandidate(value, () => {
        alert("エラーが発生しました。 お手数ですが、再度お試しください。");
        this.props.history.go(0);
      });
    };

    const handleAddSupplierCandidate = supplierIds => {
      const value = {
        sitesUC: match.params.id,
        usersUCs: supplierIds
      };

      addSupplierCandidate(value, () => {
        alert("エラーが発生しました。 お手数ですが、再度お試しください。");
        this.props.history.go(0);
      });
    };

    const showPopover = (value, userType) => event => {
      const newValue = Object.assign({ sitesUC: match.params.id }, value);
      this.setState({
        anchorEl: event.currentTarget,
        popoverValue: newValue,
        userType
      });
    };

    const closePopover = () => {
      this.setState({
        anchorEl: null
      });
    };

    const onDeleteValue = () => {
      this.setState({
        anchorEl: null
      });
      if (userType === "Builder") {
        deleteBuilderStaffCandidate(popoverValue, () => {
          alert("エラーが発生しました。 お手数ですが、再度お試しください。");
          this.props.history.go(0);
        });
      } else {
        deleteSupplierStaffCandidate(popoverValue, () => {
          alert("エラーが発生しました。 お手数ですが、再度お試しください。");
          this.props.history.go(0);
        });
      }
    };
    const setSP = () => {
      this.setState({
        isSP: true
      });
    };

    const setPC = () => {
      this.setState({
        isSP: false
      });
    };
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    let classSiteTable = "sites-table-sp";
    if (!this.state.isSP) {
      classSiteTable = "sites-table";
    }

    return (
      <>
        <Sp>
          <InfoBuilderSP
            sitesUC={this.sitesUC}
            toggleDialogStaff={toggleDialogStaff}
            toggleDialogSupplier={toggleDialogSupplier}
            showPopover={showPopover}
            setSP={setSP}
            currentUserUniqueCode={currentUserUniqueCode}
            toggleCallModal={this.toggleCallModal}
            logMeetFlag={logMeetFlag}
          />
        </Sp>
        <Pc>
          <InfoBuilder
            sitesUC={this.sitesUC}
            toggleDialogStaff={toggleDialogStaff}
            toggleDialogSupplier={toggleDialogSupplier}
            showPopover={showPopover}
            setPC={setPC}
            currentUserUniqueCode={currentUserUniqueCode}
            toggleCallModal={this.toggleCallModal}
            logMeetFlag={logMeetFlag}
          />
        </Pc>

        {receiver && (
          <div className="calling-confirm-modal">
            <div className="calling-confirm-container"
              style={{ textAlign: "center" }}
            >
              <Fab
                onClick={() => { this.toggleCallModal(null) }}
                size="small"
                className="close-button"
                style={{ backgroundColor: "#162F50" }}
              >
                <CloseIcon style={{ color: "white" }} />
              </Fab>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >この電話をかけますか？</p>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  width: "100%"
                }}
                className="text-overflow-ellipsis"
              >{receiver.name}</p>
              <Button
                onClick={() => {
                  const classification = window.location.pathname.includes("/sp/")
                  ? 1 // Supplier
                  : 0 // Builder;

                  const logMeetUrl = logmeetConfig.getLogMeetURL(window.location.hostname);
                  const url = `${logMeetUrl}?${new URLSearchParams({
                      token: configStorage().replace("Bearer ", ""),
                      siteUC: match.params.id,
                      userUC: receiver.uniqueCode,
                      role: classification
                    })}`;
                  window.open(url, '_blank').focus();
                  this.toggleCallModal(null);
                }}
                style={{
                  backgroundColor: "#162F50",
                  color: "white",
                  width: "254px",
                  height: "48px",
                  margin: "20px 0"
                }}
              >
                <PhoneIcon style={{ color: "white", width: "22px", height: "22px" }} />
                &nbsp;
                <span
                  style={{
                    fontSize: "16px",
                    fontFamily: "Noto Sans JP",
                    fontWeight: 500
                  }}
                >発信する</span>
              </Button>
            </div>
          </div>
        )}

        {
          this.props.isShowDialogStaff && (
            <InfoStaffDialog
              isShowDialogStaff={this.props.isShowDialogStaff}
              toggleDialogStaff={toggleDialogStaff}
              tableClass={classSiteTable}
              staffCandidates={staffCandidates}
              siteInfoStaff={siteInfoStaff}
              handleAddStaffCandidate={handleAddStaffCandidate}
            />
          )
        }

        {
          this.props.isShowDialogSupplier && (
            <InfoSupplierDialog
              isShowDialogSupplier={this.props.isShowDialogSupplier}
              toggleDialogSupplier={toggleDialogSupplier}
              tableClass={classSiteTable}
              supplierCandidates={supplierCandidates}
              siteInfoSupplier={siteInfoSupplier}
              handleAddSupplierCandidate={handleAddSupplierCandidate}
            />
          )
        }

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={closePopover}
          anchorOrigin={{
            vertical: "center",
            horizontal: "left"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
        >
          <MenuList className="popover-sites">
            <MenuItem onClick={onDeleteValue} className="popover-item">
              削除
            </MenuItem>
          </MenuList>
        </Popover>
      </>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  finishLoading: state.storesReducer.finishLoading,
  siteInfo: getSiteInfo(state.rootSitesReducer.siteInfoReducer.siteInfo),
  siteInfoStaff: getSiteInfoStaff(
    state.rootSitesReducer.siteInfoReducer.siteInfoStaff
  ),
  siteInfoSupplier: getSiteInfoSupplier(
    state.rootSitesReducer.siteInfoReducer.siteInfoSupplier
  ),
  staffCandidates: getStaffCandidates(
    state.rootSitesReducer.siteInfoReducer.staffCandidates
  ),
  supplierCandidates: getSupplierCandidates(
    state.rootSitesReducer.siteInfoReducer.supplierCandidates
  ),
  isShowDialogStaff: state.rootSitesReducer.siteInfoReducer.isShowDialogStaff,
  isShowDialogSupplier:
    state.rootSitesReducer.siteInfoReducer.isShowDialogSupplier,
  error: state.storesReducer.error,
  type: getType(state.rootSitesReducer.siteInfoReducer.type),
  regexObject: state.storesReducer.regexObject,
  message: state.storesReducer.message
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchSiteInfo: fetchSiteInfo,
      fetchSiteInfoStaff: fetchSiteInfoStaff,
      fetchSiteInfoSupplier: fetchSiteInfoSupplier,
      fetchStaffCandidates: fetchStaffCandidates,
      fetchSupplierCandidates: fetchSupplierCandidates,
      addStaffCandidate: addStaffCandidate,
      addSupplierCandidate: addSupplierCandidate,
      deleteBuilderStaffCandidate: deleteBuilderStaffCandidate,
      deleteSupplierStaffCandidate: deleteSupplierStaffCandidate,
      showHideDialogStaff: showHideDialogStaff,
      showHideDialogSupplier: showHideDialogSupplier,
      fetchInfoData,
      fillError
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Info));
